import React, { Component } from 'react';
import Header from '../../Layout/Header'
import { Link } from 'react-router-dom'
// import Sidebar from '../Blog/Sidebar'

class WebsiteAndNewsletterContentWriting extends Component {
	render() {
		return (
<div>
				<Header
					seoTitle="Website and Newsletter Content Writing"
					title={"website and newsletter content writing"}
					image={require('./image-6.jpg')}
				/>
				<div className="entry-content page-blog">

				<div className="container-fluid">
                       			<h2 className="outline text-center">
                            			<div className="line"></div>
                            			<div className="title">
                               			   <img
                                    			src={require("./moshi-icon.png")}
                                    			alt="Icon"
                                    			width="48"
                                    			style={{
                                    			marginTop: -18,
                                    			marginBottom: -12,
                                    			marginRight: 12
                                		   }}/>
                               			 Content Writing / Copywriting
                            			</div>
                       			 </h2>
                    		</div>

					
					<div className="container">
						
						<div className="row">
							<div className="col-lg-12">
							
								
								<p>Writing for the web is a completely different science to writing a novel or a magazine article. A well written website could be the difference between a conversion and a drop off.</p>
 <a href="https://www.moshi.com.au/what-weve-done/prince-hotel"><img src={require('./Prince-news.png')} style={{padding: 30}} height="375" width="350" alt="Prince of Wales Email Newsletter" className="align-right" align="right" /></a>
								<h4>Our rule to providing great content? Consider your audience first.</h4>
								
        <ul class="with-icons">
              <li>Who are you talking to?

</li>
              <li>What problem are you solving?


</li>
              <li>What message are you trying to put across?</li>


        </ul>
   <p>Our team at Moshi Moshi Marketing are experts in creating effective, meaningful content for websites and newsletters in Bunbury and the South West. 
</p>
<p>We thoroughly consider your brand’s ideal customer profile (one person who embodies all of your target market), and write content to them. Factors like title tags, heading1 and heading2’s, and Google keywords are also taken into consideration when writing your content, to boost your SEO and help your audience find you across more platforms. </p>


<p>
</p> <p>
</p>
<br></br>
<hr></hr>
<h2>Related Services</h2>
<a class="btn" href="https://www.moshi.com.au/whatwedo/website-development">Website Development</a> 
<a class="btn" href="https://www.moshi.com.au/whatwedo/graphic-design">Graphic Design</a>
<a class="btn" href="https://www.moshi.com.au/whatwedo/public-relations">Public Relations</a>	
<a class="btn" href="https://www.moshi.com.au/whatwedo/photography-and-video-shoots">Photography and Video Shoots</a>		
<a class="btn" href="https://www.moshi.com.au/whatwedo/email-newsletter-management">Email Newsletter Management</a>		
<a class="btn" href="https://www.moshi.com.au/whatwedo/social-media-management">Social Media Management</a>	
<hr></hr>
<br></br>
						
							</div>
							{/* <div className="col-lg-4">
								<Sidebar />
							</div> */}
						</div>
<h3>Is your web content confusing your market? Is it filled with industry specific jargon? Set up a meeting with the Moshi Moshi team and we can get you on the <b>write</b> track. </h3>
					</div>
				</div>

			</div>
		);
	}
}

export default WebsiteAndNewsletterContentWriting;


// WEBPACK FOOTER //
// ./src/Pages/WhatWeDo/WebsiteAndNewsletterContentWriting.js